import { Route, Routes } from 'react-router-dom';

import {
    AdminUserDetail,
    AdminUserList,
    AdminApiTokensDetail,
    AdminApiTokensList,
    AdminSsoDetail,
    AdminGeneralPage,
    AdminAgentSettingsDetail,
    AdminPlmList,
    AdminPlmDetailPage,
} from '.';
import {
    LastAdminPageRedirect,
    buildAdminRoute,
    buildListDetailAdminRoute,
    buildSysAdminRoute,
    LastAdminPageRedirectProvider,
} from './AdminPagesHelper';
import { NavigationMenu, PgmAdminMenu } from '../side-nav';
import { AdminPages } from './AdminPages';
import { FilterStateContainer, INITIAL_STATE } from '../../stores/FilterStateStore';
import AuthRoleGuard from '../auth/AuthRoleGuard';

const emptyFilterState = {
    ...INITIAL_STATE,
    initialized: true,
};

export default function PgmAdminPages() {
    // Admin pages don't have filter state, but they need an empty filter state for
    // the data table query loader to work.  This provides an empty, initialized state
    // so that the data table query loader will load.
    return (
        <AuthRoleGuard allowedRoles={['admin', 'super']}>
            <FilterStateContainer name="pgm-admin-filter-state" state={emptyFilterState}>
                <NavigationMenu
                    title="Global Administration"
                    lastUrl="/admin"
                    id="pgm-admin"
                    render={() => <PgmAdminMenu />}
                >
                    <LastAdminPageRedirectProvider pageKey="pgm-admin-last-page">
                        <Routes className="flex-container">
                            <Route path="/" element={<LastAdminPageRedirect defaultPage={AdminPages.Users} />} />

                            {[
                                buildListDetailAdminRoute(AdminPages.Users, AdminUserList, AdminUserDetail),
                                buildListDetailAdminRoute(
                                    AdminPages.ApiTokens,
                                    AdminApiTokensList,
                                    AdminApiTokensDetail
                                ),
                                buildAdminRoute(AdminPages.Sso, AdminSsoDetail),
                                buildSysAdminRoute(AdminPages.General, AdminGeneralPage),
                                buildAdminRoute(AdminPages.AgentSettings, AdminAgentSettingsDetail),
                                buildListDetailAdminRoute(AdminPages.Plms, AdminPlmList, AdminPlmDetailPage),
                            ]}
                        </Routes>
                    </LastAdminPageRedirectProvider>
                </NavigationMenu>
            </FilterStateContainer>
        </AuthRoleGuard>
    );
}
